import React from 'react';
import TransactionStore from '../stores/transaction-store';
import Dispatcher from '../dispatcher';
import TransactionDetailHeader from './transaction-detail-header';
import BackLinkHeader from './back-link-header';
import PurchaseItem from './purchase-item';
import {VstLoader} from 'vstui';

export default class RefundDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transaction: TransactionStore.get(this.props.number)
    };

    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.TRANSACTION_STORE_CHANGE, this._onChange);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.TRANSACTION_STORE_CHANGE, this._onChange);
  }

  _onChange() {
    this.setState({
      transaction: TransactionStore.get(this.props.number)
    });
  }

  render() {
    let body;
    const {transaction} = this.state;
    if(transaction === undefined){
      body = <div className="deck"><VstLoader /></div>;
    }else{
      let items = transaction.purchaseItems.map((i) =>{
        return <PurchaseItem item={i} transaction={transaction} key={`purchase-item-${i.isbn}`} hideRight={true} hideDownloadCodes={true} isRefund />;
      });
      body = (
        <div className="deck transaction-detail">
          <TransactionDetailHeader transaction={transaction} transactionType='refund' />
          { items }
        </div>
      );
    }

    return (
      <div className="page refund-detail">
        <BackLinkHeader alt={i18n.t('refunds.back')} href="#/transactions" title={i18n.t('transactions.refund-details')} />
        { body }
      </div>
    );
  }
};
